import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime"
import type { IFilter } from "#modules/marketplace/filtering/factory/filter/IFilter"

import { ENVIRONMENT } from "#environment/env"
import { normalizeTrailingSlash } from "#modules/localization/pathNames/pathNameUtils"

export function isRelativeUrl(url: string) {
  return !url.startsWith("http")
}

/**
 * Takes any form of http url, either relative or absolute and returns the pathname with a leading slash and without trailing slash
 */
export function pathnameFromUrl(url: string) {
  if (!isRelativeUrl(url)) {
    return normalizeTrailingSlash(new URL(url).pathname)
  }

  const normalizedPath = normalizeTrailingSlash(url)

  if (url.startsWith("/")) {
    return normalizedPath
  }

  return "/" + normalizedPath
}

/**
 * Takes any form of http url, either relative or absolute and returns an absolute cdn url without trailing slash
 */
export function withCdnUrl(url: string) {
  return ENVIRONMENT.NEXT_PUBLIC_CDN_URL + pathnameFromUrl(url)
}

function paginationString(page: number, pageSize: number, includeCount = true) {
  return `pagination[page]=${page}&pagination[pageSize]=${pageSize}&pagination[withCount]=${includeCount}`
}

function flattenAttributes<T>(strapiObjectJson: any): T {
  if (strapiObjectJson == undefined) {
    return strapiObjectJson
  }

  const object = strapiObjectJson.attributes
  object.id = strapiObjectJson.id
  return object
}

function generateQueryString(filters: IFilter[]): string {
  if (filters.length === 0) return ""

  let requestString = ""
  for (const filter of filters) {
    requestString += filter.formatRequestString() + "&"
  }
  return requestString.substring(0, requestString.length - 1)
}

function modifyQuery(modify: (searchParams: URLSearchParams) => boolean, router: AppRouterInstance, useExistingQuery = true) {
  const searchParams = new URLSearchParams(useExistingQuery ? window.location.search : "")
  if (!modify(searchParams)) return
  //TODO shallow Routing anschalten sobald es für app directory verfügbar wird, verhindert unnötigen re-render
  router.replace(`${window.location.pathname}?${searchParams.toString()}`)
}

export { paginationString, flattenAttributes, generateQueryString, modifyQuery }
